import React, { useMemo } from 'react'
import {
  FormGrid,
  Label,
  StyledTextarea,
  StyledInput,
  ScheduleContainer,
  PresetButton,
  MutedText,
  StyledAsyncSelect,
} from './TherapyRecommendationSubSection.styled'
import { useFieldMap } from '../../hooks/useFieldMap'
import { useLoadOptions } from '../../hooks/useLoadOptions'

export default function TherapyRecommendationSubSection({
  fieldValues,
  handleFieldValueChange,
  subSection,
}) {
  // Get THERAPY subsection definition
  const therapySubSection = useMemo(() => {
    return subSection
  }, [subSection])

  console.log({ therapySubSection, subSection, fieldValues })

  // Use custom hook for field mapping
  const fields = useFieldMap(therapySubSection)

  console.log({ therapyTypeField: fields.therapyTypeId, fields })

  // Use custom hook for loading therapy type options
  const loadTherapyOptions = useLoadOptions(fields.therapyTypeId, 'searchTherapyTypes', 50)

  return (
    <FormGrid>
      {/* Reason Field */}
      <Label>{fields.reason?.label}</Label>
      <div>
        <StyledTextarea
          value={fieldValues?.reason?.valueString || ''}
          onChange={(e) =>
            handleFieldValueChange(
              (prev) => ({
                ...prev,
                valueString: e.target.value,
              }),
              'reason',
            )
          }
          placeholder={fields.reason?.placeholder}
        />
        <MutedText>Keep it brief and clinical.</MutedText>
      </div>

      {/* Therapy Type Field */}
      <Label>{fields.therapyTypeId?.label}</Label>
      <StyledAsyncSelect
        classNamePrefix="react-select"
        value={
          fieldValues?.therapyTypeId?.code
            ? {
                value: fieldValues.therapyTypeId.code,
                label: fieldValues.therapyTypeId.display || fieldValues.therapyTypeId.code,
              }
            : null
        }
        onChange={(selected) => {
          handleFieldValueChange(
            (prev) => ({
              ...prev,
              code: selected?.value || '',
              display: selected?.label || '',
            }),
            'therapyTypeId',
          )
        }}
        loadOptions={loadTherapyOptions}
        debounceTimeout={300}
        placeholder={fields.therapyTypeId?.placeholder || 'Search therapy types...'}
        isClearable
        additional={{ page: 1 }}
      />

      {/* Schedule Field (Combined: frequency × weeks) */}
      <Label>Schedule</Label>
      <ScheduleContainer>
        <StyledInput
          type="number"
          min={fields.frequencyPerWeek?.min || 1}
          max={fields.frequencyPerWeek?.max || 7}
          value={fieldValues?.frequencyPerWeek?.valueNumber || 1}
          onChange={(e) =>
            handleFieldValueChange(
              (prev) => ({
                ...prev,
                valueNumber: parseInt(e.target.value) || 1,
              }),
              'frequencyPerWeek',
            )
          }
          width="70px"
        />
        <span>/week ×</span>
        <StyledInput
          type="number"
          min={fields.targetDurationWeeks?.min || 1}
          max={fields.targetDurationWeeks?.max || 52}
          value={fieldValues?.targetDurationWeeks?.valueNumber || 6}
          onChange={(e) =>
            handleFieldValueChange(
              (prev) => ({
                ...prev,
                valueNumber: parseInt(e.target.value) || 6,
              }),
              'targetDurationWeeks',
            )
          }
          width="80px"
        />
        <span>weeks</span>

        {/* Preset Buttons */}
        {[
          {
            value: 6,
            label: '6w',
          },
          { value: 8, label: '8w' },
          { value: 10, label: '10w' },
          { value: 12, label: '12w' },
        ].map((presetWeek) => (
          <PresetButton
            key={presetWeek.value}
            value={presetWeek.value}
            type="button"
            onClick={() =>
              handleFieldValueChange(
                (prev) => ({
                  ...prev,
                  valueNumber: presetWeek.value,
                }),
                'targetDurationWeeks',
              )
            }
          >
            {presetWeek.label}
          </PresetButton>
        ))}
      </ScheduleContainer>

      {/* Notes Field */}
      <Label>{fields.notes?.label}</Label>
      <StyledTextarea
        value={fieldValues?.notes?.valueString || ''}
        onChange={(e) =>
          handleFieldValueChange(
            (prev) => ({
              ...prev,
              valueString: e.target.value,
            }),
            'notes',
          )
        }
        placeholder={fields.notes?.placeholder}
      />
    </FormGrid>
  )
}
